import { render, staticRenderFns } from "./CreateAssignment.vue?vue&type=template&id=186c143e&scoped=true"
import script from "./CreateAssignment.vue?vue&type=script&lang=js"
export * from "./CreateAssignment.vue?vue&type=script&lang=js"
import style0 from "./CreateAssignment.vue?vue&type=style&index=0&id=186c143e&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "186c143e",
  null
  
)

export default component.exports